module.exports = __webpack_public_path__ + "img/dialog3.34655e2b.png";